/**
 * @param {string} periodStr e.g. "01.10.22 - 30.09.23 (2023)"
 * @returns {{ yearStart: string, yearEnd: string }}
 */
export function parseAccountingPeriodToApiDates(periodStr) {
  if (!periodStr || typeof periodStr !== "string") return { yearStart: "", yearEnd: "" };
  const parts = periodStr.split(/\s*-\s*/);
  if (parts.length < 2) return { yearStart: "", yearEnd: "" };
  const left = parts[0].trim().split(".");
  const right = parts[1].trim().split(".");
  if (left.length < 3 || right.length < 3) return { yearStart: "", yearEnd: "" };
  const y1 = Number(left[2]) < 50 ? 2000 + Number(left[2]) : 1900 + Number(left[2]);
  const y2 = Number(right[2]) < 50 ? 2000 + Number(right[2]) : 1900 + Number(right[2]);
  const iso1 = `${y1}-${String(left[1]).padStart(2, "0")}-${String(left[0]).padStart(2, "0")}`;
  const iso2 = `${y2}-${String(right[1]).padStart(2, "0")}-${String(right[0]).padStart(2, "0")}`;
  return { yearStart: iso1, yearEnd: iso2 };
}

/**
 * @param {string} ownershipUi
 * @returns {string} API ownership code used elsewhere in app
 */
export function mapOwnershipToApi(ownershipUi) {
  const o = String(ownershipUi || "").trim();
  if (!o) return "sole";
  if (o === "Wholly owned asset" || o === "Selvejet") return "sole";
  if (o === "Leased") return "leased";
  if (o === "Partially owned") return "partial";
  if (o === "Franchise") return "franchise";
  return "sole";
}

export function defaultOwnershipPercent(ownershipUi) {
  const o = String(ownershipUi || "").trim();
  if (o === "Wholly owned asset" || o === "Selvejet") return 100;
  if (o === "Franchise") return 100;
  return "";
}

/**
 * @param {string} buildingTypeEn
 * @param {(k: string) => string} t i18n
 */
export function buildCheckedTypesForSingleBuilding(buildingTypeEn, t) {
  const label = String(buildingTypeEn || "").trim() || "Other";
  return [
    {
      name_en: label,
      checked: true,
      space_percentage: 100,
    },
  ];
}

export function buildAddressLine1({ street, city, postalCode, country }) {
  return [street, postalCode, city, country]
    .map((x) => String(x || "").trim())
    .filter(Boolean)
    .join(", ");
}
